import React, { useEffect, useState } from 'react';

export const CURRENT_INSPECTOR_ACADEMIC_YEAR = 2026;

export const INSPECTOR_SUPPORTED_YEARS = {
  elementary: [2026, 2025, 2024, 2023, 2022, 2021],
  middle: [2026, 2025, 2024],
  high: [2026, 2025, 2024],
};

export const INSPECTOR_GRADES = {
  elementary: [1, 2, 3, 4, 5, 6],
  middle: [1, 2, 3],
  high: [1, 2, 3],
};

export const normalizeInspectorAcademicYear = (schoolLevel, academicYear) => {
  const supported = INSPECTOR_SUPPORTED_YEARS[schoolLevel]
    || INSPECTOR_SUPPORTED_YEARS.elementary;
  const numericYear = Number(academicYear);
  return supported.includes(numericYear)
    ? numericYear
    : CURRENT_INSPECTOR_ACADEMIC_YEAR;
};

export const isValidInspectorGrade = (schoolLevel, recordGrade) => {
  const grades = INSPECTOR_GRADES[schoolLevel] || [];
  return grades.includes(Number(recordGrade));
};

export const getInspectorGuidelineContextLabel = (
  academicYear,
  recordGrade,
) => {
  if (!academicYear) return '적용 기준 미기록';
  if (!recordGrade) return `${academicYear}학년도 · 학년 공통`;
  return `${academicYear}학년도 · ${recordGrade}학년`;
};

const InspectorGuidelineContextSelector = ({
  academicYear,
  disabled = false,
  idPrefix = 'inspector',
  onAcademicYearChange,
  onRecordGradeChange,
  recordGrade,
  schoolLevel,
  showGradeError = false,
}) => {
  const years = INSPECTOR_SUPPORTED_YEARS[schoolLevel] || [];
  const grades = INSPECTOR_GRADES[schoolLevel] || [];
  const hasValidGrade = isValidInspectorGrade(schoolLevel, recordGrade);
  const [isExpanded, setIsExpanded] = useState(
    !hasValidGrade || showGradeError,
  );
  const contextLabel = getInspectorGuidelineContextLabel(
    academicYear,
    recordGrade,
  );
  useEffect(() => {
    if (!hasValidGrade || showGradeError) setIsExpanded(true);
  }, [hasValidGrade, showGradeError]);

  if (!isExpanded && hasValidGrade) {
    return (
      <div className="inspector-guideline-context inspector-guideline-context--summary">
        <button
          aria-expanded="false"
          className="inspector-context-summary-button"
          disabled={disabled}
          onClick={() => setIsExpanded(true)}
          type="button"
        >
          <span>
            <small>작성 기준</small>
            <strong>{contextLabel}</strong>
          </span>
          <span className="inspector-context-change">변경</span>
        </button>
      </div>
    );
  }

  return (
    <div className="inspector-guideline-context inspector-guideline-context--editor">
      <div className="inspector-guideline-context-header">
        <div>
          <strong>작성 기준</strong>
          <span>기록을 작성한 당시 학년도와 학년이에요</span>
        </div>
        {hasValidGrade && (
          <button
            disabled={disabled}
            onClick={() => setIsExpanded(false)}
            type="button"
          >
            완료
          </button>
        )}
      </div>
      <div className="inspector-guideline-context-fields">
        <label htmlFor={`${idPrefix}-academic-year`}>
          <span>학년도</span>
          <select
            aria-label="작성 학년도"
            disabled={disabled}
            id={`${idPrefix}-academic-year`}
            onChange={(event) => onAcademicYearChange(Number(event.target.value))}
            value={academicYear}
          >
            {years.map((year) => (
              <option key={year} value={year}>{year}학년도</option>
            ))}
          </select>
        </label>
        <label htmlFor={`${idPrefix}-record-grade`}>
          <span>학년</span>
          <select
            aria-describedby={showGradeError ? `${idPrefix}-grade-error` : undefined}
            aria-invalid={showGradeError}
            aria-label="작성 당시 학년"
            className={showGradeError ? 'inspector-context-select--error' : ''}
            disabled={disabled}
            id={`${idPrefix}-record-grade`}
            onChange={(event) => {
              const nextGrade = event.target.value
                ? Number(event.target.value)
                : '';
              onRecordGradeChange(nextGrade);
              if (nextGrade) setIsExpanded(false);
            }}
            required
            value={recordGrade}
          >
            <option value="">학년 선택</option>
            {grades.map((grade) => (
              <option key={grade} value={grade}>{grade}학년</option>
            ))}
          </select>
        </label>
      </div>
      {showGradeError && (
        <p className="inspector-context-error" id={`${idPrefix}-grade-error`}>
          기록을 작성한 당시 학년을 선택해주세요.
        </p>
      )}
    </div>
  );
};

export default InspectorGuidelineContextSelector;
